export default "__VITE_PUBLIC_ASSET__079ed538__"